import React, { useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';
function groupDigits(value: string): string {
  const digits = value.replace(/\s/g, '');
  const lead = digits.length % 2 === 1 ? digits.slice(0, 1) : '';
  const rest = digits.slice(lead ? 1 : 0);
  const pairs = rest.match(/.{1,2}/g) ?? [];
  return [lead, ...pairs].filter(Boolean).join(' ');
}
interface CardNumberProps {
  value: string;
}
export function CardNumber({
  value
}: CardNumberProps) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      /* clipboard unavailable */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };
  return <button type="button" onClick={copy} aria-label={`Copy number ${value}`} className="group relative mx-auto block h-8 overflow-hidden rounded-lg px-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-378" data-mp="1vo5l02tla0i9">
      <span className="pointer-events-none block font-mono text-xl leading-8 tracking-[0.12em] text-ville-navy transition-transform duration-200 ease-ville group-hover:translate-y-8 group-focus-visible:translate-y-8" data-id="element-379" data-mp="2unh8p63alc0l">
        {groupDigits(value)}
      </span>
      <span className="pointer-events-none absolute inset-x-0 top-0 flex -translate-y-8 items-center justify-center gap-1.5 text-[15px] font-bold leading-8 text-ville-indigo transition-transform duration-200 ease-ville group-hover:translate-y-0 group-focus-visible:translate-y-0" data-id="element-380" data-mp="2ky7d3g98pb7q">
        {copied ? <>
            <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-381" data-mp="38o1pjwpncxrg" />
            Copied
          </> : <>
            <CopyIcon className="h-4 w-4" aria-hidden="true" data-id="element-382" data-mp="34ju1m1r0jlua" />
            Copy
          </>}
      </span>
    </button>;
}